#@import GliveBooking.Presenters.TimePicker
#@import GliveBooking.Views.Picker
#@import GliveBooking.Views.Times
#@export GliveBooking.Views.TimePicker

class GliveBooking.Views.TimePicker extends GliveBooking.Views.Picker

  module: 'glive-booking'

  presenter: GliveBooking.Presenters.TimePicker

  contentView: GliveBooking.Views.Times

  templateName: 'timepicker'

  attributes: ->
    'data-bhw': "#{GliveBooking.bhw}Times"

  styleClassName: 'times'
